<template>
  <div class="footer">
    <div class="icon-row">
      <a
        href="https://www.facebook.com/teuteufgames/"
        class="link"
        target="_blank"
        rel="noreferrer"
      >
        <img src="/facebook.png" alt="facebook" class="icon" />
      </a>
      <a href="https://www.tiktok.com/@teuteufgames" class="link" target="_blank" rel="noreferrer">
        <img src="/tik-tok.png" alt="tiktok" class="icon" />
      </a>
      <a
        href="https://www.instagram.com/teuteufgames"
        class="link"
        target="_blank"
        rel="noreferrer"
      >
        <img src="/instagram.png" alt="instagram" class="icon" />
      </a>
    </div>
    <a class="logo" href="https://teuteuf.fr" target="_blank" rel="noopener noreferrer">
      <img src="/teuteuf.svg" alt="teuteuf logo" />
    </a>
    <a
      class="easter-egg"
      href="https://challenge.teuteuf.fr"
      target="_blank"
      rel="noopener noreferrer"
    >
      ⚔️
    </a>
  </div>
</template>

<script>
  export default {
    name: 'AppFooter',
  };
</script>

<style scoped>
  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin: 24px 12px;
  }

  .icon-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
  }

  .icon {
    width: 24px;
    height: 24px;
  }

  .link {
    width: 40px;
    height: 40px;
    background-color: rgba(173, 173, 234, 1);
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo {
    display: block;
    width: 200px;
    max-width: 100%;
  }

  .logo img {
    width: 100%;
    height: 16px;
  }

  .easter-egg {
    text-decoration: none;
    color: white;
  }
</style>
